export default __webpack_public_path__ + "static/media/spec-bottomsheet-size.ed4f92e5.png";